import LiquidButton from './liquid-button.js'

export default class Button {
  constructor(el) {
    this.el = el
    this.svg = el.querySelector('.btn--picto svg')
    this.init()
  }

  init() {
    this.initText()
    this.initLiquid()
  }

  initText() {
    const label = this.el.querySelector('.btn--label span')
    if (!label) return

    label.innerHTML = label.textContent.split('').map(char =>
      char === ' '
        ? '<span class="btn--char btn--char-space"> </span>'
        : `<span class="btn--char">${char}</span>`
    ).join('')

    // Capture positions d'origine après layout
    requestAnimationFrame(() => {
      const btnRect = this.el.getBoundingClientRect()
      this.charStates = [...this.el.querySelectorAll('.btn--char')].map(el => ({
        el,
        ox: el.getBoundingClientRect().left + el.getBoundingClientRect().width / 2 - btnRect.left,
        oy: el.getBoundingClientRect().top  + el.getBoundingClientRect().height / 2 - btnRect.top,
        x: 0, y: 0, vx: 0, vy: 0,
      }))

      this.textMouse = null
      this.textActive = false

      this.el.addEventListener('mousemove', (e) => {
        const r = this.el.getBoundingClientRect()
        this.textMouse = { x: e.clientX - r.left, y: e.clientY - r.top }
        if (!this.textActive) { this.textActive = true; this.animateText() }
      })
      this.el.addEventListener('mouseleave', () => { this.textMouse = null })
    })
  }

  animateText() {
    let stillMoving = !!this.textMouse

    for (const s of this.charStates) {
      if (this.textMouse) {
        const dx   = (s.ox + s.x) - this.textMouse.x
        const dy   = (s.oy + s.y) - this.textMouse.y
        const dist = Math.sqrt(dx * dx + dy * dy) || 1
        const r    = 35
        if (dist < r) {
          const force = ((r - dist) / r) * 0.8
          s.vx += (dx / dist) * force
          s.vy += (dy / dist) * force
        }
      }

      // Ressort vers l'origine
      s.vx += -s.x * 0.22
      s.vy += -s.y * 0.22
      s.vx *= 0.85
      s.vy *= 0.85
      s.x  += s.vx
      s.y  += s.vy

      s.el.style.transform = `translate(${s.x.toFixed(2)}px, ${s.y.toFixed(2)}px)`

      if (Math.abs(s.x) > 0.05 || Math.abs(s.y) > 0.05) stillMoving = true
    }

    if (stillMoving) requestAnimationFrame(() => this.animateText())
    else this.textActive = false
  }

  lighten(color, amount) {
    const m = color.match(/\d+/g)
    if (!m) return color
    const [r, g, b] = m.map(Number)
    return `rgb(${Math.min(255, r + amount)}, ${Math.min(255, g + amount)}, ${Math.min(255, b + amount)})`
  }

  initLiquid() {
    const setup = () => {
      const rect = this.el.getBoundingClientRect()
      if (!rect.width) { requestAnimationFrame(setup); return }

      const cs     = getComputedStyle(document.documentElement)
      const margin = 50

      let color1, color2, color3
      if (this.el.classList.contains('btn--gradient')) {
        color1 = cs.getPropertyValue('--color-5').trim()        || '#7842F2'
        color2 = cs.getPropertyValue('--color-6').trim()        || '#511DD1'
        color3 = cs.getPropertyValue('--color-tertiary').trim() || '#C85DAE'
      } else {
        const bg = getComputedStyle(this.el).backgroundColor
        color1 = bg
        color2 = this.lighten(bg, 25)
        color3 = this.lighten(bg, 50)
      }

      const canvas = document.createElement('canvas')
      canvas.style.cssText = `position:absolute;top:${-margin}px;left:${-margin}px;pointer-events:none;z-index:0`
      this.el.prepend(canvas)

      const btn = new LiquidButton({
        canvas,
        width:  rect.width,
        height: rect.height,
        margin,
        color1,
        color2,
        color3,
      })


      this.el.addEventListener('mousemove', (e) => {
        const r = this.el.getBoundingClientRect()
        btn.touches = [{ x: (e.clientX - r.left) + margin, y: (e.clientY - r.top) + margin, z: 0, force: 1 }]
      })
      this.el.addEventListener('mouseleave', () => { btn.touches = [] })
    }

    requestAnimationFrame(setup)
  }

}
